import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../sounds/correctAnswerBling.wav'
import wrongAnswerBuzz from '../sounds/wrongAnswerBuzz.wav'
import Button from 'react-bootstrap/Button';
import { shufflaa } from '../utils/randomize'
import kuva from '../images/get_out.jpg'



const Scene_get_out2 = ({ visibilityHandler }) => {


    return (


        <div className='sceneContainer'>

            <div id='image'>
                <img src={kuva} alt='kuva' />
            </div>

            <div id='teksti'>
                <h5>Teija keskeyttää toimintasi</h5>
            </div>

            <div id='actions'>
                <Button onClick={() => visibilityHandler("play again")}>Pelaa uudelleen</Button><br />

            </div>
        </div>

    )

}

export default Scene_get_out2